import { useState } from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import useDisclosure from "../../../actprep-ui/hooks/ui/useDisclosure";
import StudentTableDialog from "../../../components/StudentTableDialog";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";

export default function Cohorts() {
  const [dialogTitle, setDialogTitle] = useState("");
  const [selectedCohortUUID, setSelectedCohortUUID] = useState(null);
  const disclosure = useDisclosure();
  const { onOpen } = disclosure;

  const handleRowClick = (params) => {
    setSelectedCohortUUID(params.row.uuid);
    setDialogTitle(`Students in '${params.row.event_name}' Cohort`);
    onOpen();
  };

  const cohortsColumns = [
    {
      field: "event_name",
      headerName: "Cohort Name",
      width: 200,
      valueGetter: (value, row) => row.event_name || "",
    },
    {
      field: "student_count",
      headerName: "Number of Students",
      type: "number",
      width: 150,
    },
  ];

  return (
    <>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
        }}
        size={12}
      >
        <ContentBox style={{ maxHeight: "85vh", height: "500rem" }}>
          <Typography variant="h5" fontWeight="bold">
            Cohorts
          </Typography>
          <Box sx={{ height: "90%" }}>
            <PaginatedTable
              searchable
              tableName={"Cohorts"}
              apiUrl={apiUrls.admin.cohorts()}
              columns={cohortsColumns}
              urlParams={{
                keep_related: "true",
                values: ["event_name", "student_count", "uuid"],
              }}
              sortingMode={sortingModes.SERVER}
              disableCellFocus
              onRowClick={handleRowClick}
            />
          </Box>
        </ContentBox>
      </Grid>
      <StudentTableDialog
        title={dialogTitle}
        filterParams={{
          search_params: {
            cohort_id: selectedCohortUUID,
          },
        }}
        {...disclosure}
      />
    </>
  );
}
